























































































































































































































































































































































































































































































































































































import { plainToClass, serialize } from "class-transformer";
import { Component, Inject, Mixins, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import BeforeUnload from "../../mixins/BeforeUnload";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import { Utils as FnUtils } from "../../Utils";
import FormDirtyOnLeavePage from "../private/forms/FormDirtyOnLeavePage.vue";
import { DetailSections, ProjectProposalDetails } from "../../models/ProjectProposal";
import {
    Categories,
    ContactOtherTypes,
    ContactTypes,
    LegalNatures,
    Locality,
    PartnershipTypes,
    Person,
    Positions
} from "../../models/Decoding";
import PersonsListModal from "../private/PersonsListModal.vue";
import LocalitiesListModal from "../private/LocalitiesListModal.vue";
import {
    CONTACT_OTHER,
    // CONTACT_SAME_APPL,
    CONTACT_SAME_LEAD,
    LEAD_DIFF_APPL,
    LEAD_SAME_APPL,
    PARTNERSHIP,
    PARTNERSHIP_OTHER
} from "../../models/Form";
import { Debounce } from "vue-debounce-decorator";

@Component({
    beforeRouteLeave(this: ProjectProposalForm, to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        this.isDirty ? (this.showModal = true) : next();
    },
    components: {
        FormDirtyOnLeavePage,
        PersonsListModal,
        LocalitiesListModal
    }
})
export default class ProjectProposalForm extends Mixins(ProjectProposalMixin, Utils, BeforeUnload) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;

    response: ProjectProposalDetails | null = null;
    sections: DetailSections | null = null;
    loading = true;
    originalData = "";
    showModal = false;
    isDirty = false;
    isValid: string[] = [];
    natureCategories: Categories = new Categories();
    legalNatures: LegalNatures = new LegalNatures();
    partnershipTypes: PartnershipTypes = new PartnershipTypes();
    contactTypes: ContactTypes = new ContactTypes();
    contactOtherTypes: ContactOtherTypes = new ContactOtherTypes();
    positions: Positions = new Positions();
    debouncedSearch = 0;
    searchApplicantPerson = "";
    filteredApplicantPersonValues: Person[] = [];
    selectedApplicantPerson: Person | null = null;
    searchLocality = "";
    filteredLocalityValues: Locality[] = [];
    selectedLocality: Locality | null = null;
    showLocalitiesListModal = false;
    projectLeaderType = "";
    searchLeaderPerson = "";
    filteredLeaderPersonValues: Person[] = [];
    selectedLeaderPerson: Person | null = null;
    searchContactPerson = "";
    filteredContactPersonValues: Person[] = [];
    selectedContactPerson: Person | null = null;

    get nameLabel() {
        return `Name${this.contract?.isProdInvests ? " (Entity or individual name)" : ""}`;
    }

    get idCardLabel() {
        return this.contract?.isProdInvests ? "Unique Identification number" : "ID Card";
    }

    get uniqueIdInfo() {
        return `In case of:
        <ul class="list-disc list-inside">
            <li>Individual: ID card number</li>
            <li>Company: Company number</li>
            <li>NGO: VO number</li>
            <li>Partnership: Partnership number</li>
        <ul>`;
    }
    get gender_tip() {
        return `If this information is incorrect, kindly contact Front Office on 22926148 to update accordingly.`;
    }

    get isSameLeadContact() {
        return this.response?.contact_person_sotto_codice === CONTACT_SAME_LEAD;
    }

    get isOtherContact() {
        return this.response?.contact_person_sotto_codice === CONTACT_OTHER;
    }

    get canViewLeaderSearch() {
        return /*this.projectLeaderType === LEAD_DIFF_APPL &&*/ this.canEdit;
    }

    get isPartnership() {
        return this.response?.natura_giuridica === PARTNERSHIP;
    }

    get isPartnershipOther() {
        return this.response?.partnership_sotto_codice === PARTNERSHIP_OTHER;
    }

    get categoryTitle() {
        return this.natureCategories.records.length > 0 ? this.natureCategories?.records[0].titolo : "";
    }

    get legalNaturesTitle() {
        return this.legalNatures.records.length > 0 ? this.legalNatures?.records[0].descrizione : "";
    }

    get genderLabel(): string {
        switch (this.response?.gender) {
        case 'M':
            return 'Male';
        case 'F':
            return 'Female';
        case 'D':
            return 'Diverse';
        default:
            return '';  
        }
    }

    get showDurationTip() {
        const intervention = this.contract?.intervention;
        return intervention !== 'I73.5' && intervention !== 'I73.5.1'
    }

    durationRule(v: number) {
        const maxDuration = Number(this.sections?.duration_in_months_number || 1);  
        return v <= maxDuration 
            ? true 
            : `Maximum project duration is ${maxDuration} months`;
    }
    emailRule(v: string) {
        return FnUtils.validateEmail(v) || "Invalid email address";
    }

    @Watch("response", { deep: true })
    onRowsChange() {
        this.setBeforeUnload();
    }

    @Watch("response.partnership_sotto_codice")
    onPartnershipChange(_newVal: string, oldVal: string) {
        if (this.response && oldVal) this.response.partnership_other = null;
    }

    @Watch("selectedNatures")
    onSelectedNaturesChange() {
        if (this.response) {
            this.response.partnership_other = null;
            this.response.partnership_sotto_codice = null;
        }
    }

    async loadData() {
        this.loading = true;
        await this.loadDetails();
        await this.loadCategories();
        await this.loadPartnershipTypes();
        await this.loadPositions();
        await this.loadContactTypes();
        await this.loadContactOtherTypes();
        await this.loadLegalNatures();
        await this.loadSections();
        this.loading = false;
    }

    async mounted() {
        await this.loadData();
    }

    backToHome(force = false) {
        if (force) {
            this.unsetBeforeUnload();
            this.originalData = serialize(this.response);
        }
        this.isDirty = this.originalData !== serialize(this.response);
        this.goHome();
    }

    async loadSections() {
        const [data, err] = await this.maltaModule.projectProposalApi.getDetailSections(
            this.subjectId,
            this.applicationId
        );
        if (err) this.goHomeGenericError();
        else if (data) this.sections = data;
    }

    async loadCategories() {
        const [data, err] = await this.maltaModule.decodingApi.getNatureCategories(this.subjectId, this.applicationId);
        if (err) this.goHomeGenericError();
        else if (data) {
            this.natureCategories = data;
            if (this.response && this.natureCategories.records.length > 0)
                this.response.id_category = this.natureCategories.records[0].id_category;
        }
    }

    async loadPartnershipTypes() {
        const [data, err] = await this.maltaModule.decodingApi.getPartnershipTypes(this.subjectId, this.applicationId);
        if (err) this.goHomeGenericError();
        else if (data) this.partnershipTypes = data;
    }

    async loadPositions() {
        const [data, err] = await this.maltaModule.decodingApi.getPositions(this.subjectId, this.applicationId);
        if (err) this.goHomeGenericError();
        else if (data) this.positions = data;
    }

    async loadContactTypes() {
        const [data, err] = await this.maltaModule.decodingApi.getContactTypes(this.subjectId, this.applicationId);
        if (err) this.goHomeGenericError();
        else if (data) this.contactTypes = data;
    }

    async loadContactOtherTypes() {
        const [data, err] = await this.maltaModule.decodingApi.getContactOtherTypes(this.subjectId, this.applicationId);
        if (err) this.goHomeGenericError();
        else if (data) this.contactOtherTypes = data;
    }

    async loadDetails() {
        const [data, err] = await this.maltaModule.projectProposalApi.getProjectDetail(
            this.subjectId,
            this.applicationId
        );
        if (err) this.goHomeGenericError();
        else if (data) {
            this.originalData = serialize(data);
            this.response = data;
            this.selectedLocality = plainToClass(Locality, {
                codi_fisc_luna: this.response.applicant_city,
                locality_description: this.response.applicant_locality_description
            });
        }
    }

    async loadLegalNatures() {
        if (this.response && this.response.id_category) {
            const [data, err] = await this.maltaModule.decodingApi.getLegalNatures(
                this.subjectId,
                this.applicationId,
                this.response.id_category
            );
            if (err) this.goHomeGenericError();
            else if (data) {
                this.legalNatures = data;
                if (this.legalNatures.records.length > 0)
                    this.response.natura_giuridica = this.legalNatures.records[0].codice.toString();
            }
        }
    }

    async saveAndGoBack() {
        if (this.response) {
            this.loading = true;
            this.isValid = this.response.isValid(this.contract, this.sections);
            if (this.isValid.length === 0) {
                const [resp, err] = await this.maltaModule.projectProposalApi.setProjectDetails(
                    this.subjectId,
                    this.applicationId,
                    this.response
                );
                if (err) this.toast(this.i18n("something-went-wrong").toString(), { type: "error" });
                else {
                    this.unsetBeforeUnload();
                    this.originalData = serialize(resp);
                    this.response = resp;
                    this.isDirty = false;
                    this.$emit("reload");
                    this.toast(this.i18n("saved-item").toString(), { type: "success" });
                    this.goHome(true);
                }
            } else this.toast(this.i18n("form-not-valid").toString(), { type: "error" });
            this.loading = false;
        }
    }

    beforeDestroy() {
        this.unsetBeforeUnload();
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    personsToString(person: Person | null): string {
        return person ? `${person.name} ${person.surname}` : "";
    }

    @Debounce(500)
    @Watch("searchApplicantPerson")
    async filterApplicantPersonValues() {
        let ret: Person[] = [];
        const data = await this.maltaModule.decodingApi.getPerson(
            this.subjectId,
            this.applicationId,
            this.searchApplicantPerson
        );
        if (data) {
            if (this.searchApplicantPerson != "") {
                ret = [...ret, ...data.records];
                this.filteredApplicantPersonValues = ret;
                return;
            }

            ret = data.records;
        }
        this.filteredApplicantPersonValues = ret;
    }

    @Watch("selectedApplicantPerson")
    onApplicantPersonSelected(): void {
        this.searchApplicantPerson = this.selectedApplicantPerson
            ? `${this.selectedApplicantPerson.name} ${this.selectedApplicantPerson.surname}`
            : "";
        if (this.response && this.selectedApplicantPerson) {
            this.response.applicant = this.selectedApplicantPerson;
            this.selectedLocality = plainToClass(Locality, {
                codi_fisc_luna: this.selectedApplicantPerson.cod_belf_residenza,
                locality_description: this.selectedApplicantPerson.locality_description
            });
            this.searchApplicantPerson = "";
            this.selectedApplicantPerson = null;
        }
    }

    onApplicantPersonReset(): void {
        if (this.response) {
            this.searchApplicantPerson = "";
            this.selectedApplicantPerson = null;
            this.response.applicant = this.selectedApplicantPerson;
        }
    }

    @Watch("response.contact_person_sotto_codice")
    setContact(_newVal: string, oldVal: string) {
        if (this.response && oldVal !== undefined) {
            this.response.contact_person_other_sotto_codice = null;
            switch (this.response.contact_person_sotto_codice) {
                // case CONTACT_SAME_APPL:
                //     this.response.contact = this.response.applicant;
                //     break;
                case CONTACT_SAME_LEAD:
                    this.response.contact = this.response.leader;
                    break;
                default:
                    this.response.contact = null;
                    break;
            }
        }
    }

    @Debounce(500)
    @Watch("searchLeaderPerson")
    async filterLeaderPersonValues() {
        let ret: Person[] = [];
        const data = await this.maltaModule.decodingApi.getPerson(
            this.subjectId,
            this.applicationId,
            this.searchLeaderPerson
        );
        if (data) {
            if (this.searchLeaderPerson != "") {
                ret = [...ret, ...data.records];
                this.filteredLeaderPersonValues = ret;
                return;
            }

            ret = data.records;
        }
        this.filteredLeaderPersonValues = ret;
    }

    @Watch("selectedLeaderPerson")
    onLeaderPersonSelected(): void {
        this.searchLeaderPerson = this.selectedLeaderPerson
            ? `${this.selectedLeaderPerson.name} ${this.selectedLeaderPerson.surname}`
            : "";
        if (this.response && this.selectedLeaderPerson) {
            this.response.leader = this.selectedLeaderPerson;
            this.searchLeaderPerson = "";
            this.selectedLeaderPerson = null;
        }
    }

    onLeaderPersonReset(): void {
        if (this.response) {
            this.searchLeaderPerson = "";
            this.selectedLeaderPerson = null;
            this.response.leader = this.selectedLeaderPerson;
        }
    }

    @Watch("projectLeaderType")
    setLeader() {
        if (this.response)
            if (this.projectLeaderType === LEAD_SAME_APPL) this.response.leader = this.response.applicant;
            else this.response.leader = null;
    }

    @Debounce(500)
    @Watch("searchContactPerson")
    async filterContactPersonValues() {
        let ret: Person[] = [];
        const data = await this.maltaModule.decodingApi.getPerson(
            this.subjectId,
            this.applicationId,
            this.searchContactPerson
        );
        if (data) {
            if (this.searchContactPerson != "") {
                ret = [...ret, ...data.records];
                this.filteredContactPersonValues = ret;
                return;
            }

            ret = data.records;
        }
        this.filteredContactPersonValues = ret;
    }

    @Watch("selectedContactPerson")
    onContactPersonSelected(): void {
        this.searchContactPerson = this.selectedContactPerson
            ? `${this.selectedContactPerson.name} ${this.selectedContactPerson.surname}`
            : "";
        if (this.response && this.selectedContactPerson) {
            this.response.contact = this.selectedContactPerson;
            this.searchContactPerson = "";
            this.selectedContactPerson = null;
        }
    }

    onContactPersonReset(): void {
        if (this.response) {
            this.searchContactPerson = "";
            this.selectedContactPerson = null;
            this.response.contact = this.selectedContactPerson;
        }
    }

    localitiesToString(locality: Locality | null): string {
        return locality ? locality.locality_description : "";
    }

    @Debounce(500)
    @Watch("searchLocality")
    async filterLocalityValues() {
        let ret: Locality[] = [];
        const data = await this.maltaModule.decodingApi.getLocality(
            this.subjectId,
            this.applicationId,
            this.searchLocality
        );
        if (data) {
            if (this.searchLocality != "") {
                ret = [...ret, ...data.records];
                this.filteredLocalityValues = ret;
                return;
            }

            ret = data.records;
        }
        this.filteredLocalityValues = ret;
    }

    @Watch("selectedLocality")
    onLocalitySelected(): void {
        if (this.response && this.selectedLocality) {
            this.response.locality = this.selectedLocality;
            this.searchLocality = this.selectedLocality ? this.selectedLocality.locality_description : "";
        }
    }

    onLocalityReset(): void {
        if (this.response) {
            this.searchLocality = "";
            this.selectedLocality = null;
            this.response.locality = this.selectedLocality;
        }
    }

    openLocalitiesListModal(): void {
        this.showLocalitiesListModal = true;
    }

    setLeaderAsApplicant() {
        this.projectLeaderType = LEAD_SAME_APPL;
    }

    setLeaderDifferentFromApplicant() {
        this.projectLeaderType = LEAD_DIFF_APPL;
    }

    setContactAsLeader() {
        if (this.response) this.response.contact_person_sotto_codice = CONTACT_SAME_LEAD;
    }

    setContactAsOther() {
        if (this.response) this.response.contact_person_sotto_codice = CONTACT_OTHER;
    }
}
